<template>
  <button
      data-test-id="login-link"
      class="login-link"
      @click="$emit('login')"
  >
    <Icon name="user"/>
    {{ t('home_header.component_login_button.text') }}
  </button>
</template>

<script>
import { useI18n } from 'vue-i18n'
import Icon from '@/components/partials/Icon.vue'

export default {
  components: { Icon },

  emits: ['login'],

  setup() {
    const { t } = useI18n()

    return {
      t,
    }
  },
}
</script>

<style lang="scss" scoped>
.login-link {
  text-align:  center;
  padding:     0.5rem 1rem;
  margin:      1rem auto 0;
  display:     block;
  cursor:      pointer;
  display:     flex;
  gap:         1rem;
  align-items: center;
  justify-content: center;
}
</style>
